// extracted by mini-css-extract-plugin
export default {"hidden":"ContactListItem_hidden__AuzqK","item":"ContactListItem_item__H4FaV","itemBox":"ContactListItem_itemBox__Sh4Fo","buttonsBox":"ContactListItem_buttonsBox__gk5up"};